export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

type ClientEnv = {
  appId: string;
  appTitle: string;
  appLogo: string;
  oauthPortalUrl: string;
  analyticsEndpoint?: string;
  authProvider: "manus" | "custom" | string;
};

export function getClientEnv(): ClientEnv {
  const env = (import.meta as any).env || {};

  const appId = env.VITE_APP_ID as string | undefined;
  const appTitle = env.VITE_APP_TITLE as string | undefined;
  const appLogo = env.VITE_APP_LOGO as string | undefined;
  const oauthPortalUrl =
    (env.VITE_OAUTH_PORTAL_URL as string | undefined) || "https://manus.im";
  const analyticsEndpoint = env.VITE_ANALYTICS_ENDPOINT as string | undefined;
  const authProvider = (env.VITE_AUTH_PROVIDER as string) || "manus";

  if (!appId) {
    console.error("VITE_APP_ID is missing in environment");
  }
  if (!oauthPortalUrl) {
    console.error("VITE_OAUTH_PORTAL_URL is missing in environment");
  }

  return {
    appId: appId || "dev-app",
    appTitle: appTitle || "City Water Well Logging",
    appLogo: appLogo || "/logo.svg",
    oauthPortalUrl,
    analyticsEndpoint,
    authProvider,
  };
}

/**
 * Generate login URL at runtime so redirect URI reflects the current origin.
 * Now uses Vite environment variables only and respects VITE_AUTH_PROVIDER
 */
export const getLoginUrl = (): string => {
  const clientEnv = getClientEnv();
  const oauthPortalUrl = clientEnv.oauthPortalUrl;
  const appId = clientEnv.appId;
  const authProvider = clientEnv.authProvider;

  // If using custom auth provider, return local login URL
  if (authProvider === "custom") {
    const redirectUri = `${window.location.origin}`;
    const url = new URL(`${window.location.origin}/login`);
    if (redirectUri) {
      url.searchParams.set("redirect", redirectUri);
    }
    return url.toString();
  }

  // Manus auth provider (default)
  if (!oauthPortalUrl || !oauthPortalUrl.startsWith("http")) {
    console.error("oauthPortalUrl is not set or invalid:", oauthPortalUrl);
    throw new Error("Missing oauthPortalUrl configuration");
  }

  try {
    const redirectUri = `${window.location.origin}/api/oauth/callback`;
    const state = btoa(redirectUri);

    const url = new URL(`${oauthPortalUrl}/app-auth`);
    url.searchParams.set("appId", appId);
    url.searchParams.set("redirectUri", redirectUri);
    url.searchParams.set("state", state);
    url.searchParams.set("type", "signIn");

    return url.toString();
  } catch (err) {
    console.error("Invalid oauthPortalUrl", oauthPortalUrl, err);
    return `${window.location.origin}/login`;
  }
};
